import { z } from "zod";
import { parseAmount } from "@/util/sums";
import { phonePattern } from "./shared";
import { registerUserSchema } from "./register";

const amount = (message: string) =>
  z
    .string()
    .trim()
    .refine((value) => /\d/.test(value) && parseAmount(value) > 0, message);

const selection = z.string().min(1, "Please select an option");

export const enquiryDetailsSchema = registerUserSchema.extend({
  phone: z
    .string()
    .transform((value) => value.replace(/\s+/g, ""))
    .pipe(z.string().regex(phonePattern, "A valid phone number is required")),
});

export const enquirySituationSchema = z.object({
  buyingWith: selection,
  employmentStatus: selection,
  annualIncome: amount("Enter your combined annual income"),
  depositSavings: amount("Enter the savings you have for a deposit"),
  propertyOwnership: selection,
  monthlyDebts: z.string().trim().regex(/\d/, "Enter your monthly repayments, or 0 if you have none"),
});

export const enquiryGoalsSchema = z.object({
  location: z.string().trim().min(2, "Enter a suburb, city or postcode"),
  targetPrice: amount("Enter your target property price"),
  timeframe: selection,
  propertyType: selection,
  loanApproval: amount("Enter your expected home loan approval"),
  priorities: z.string().trim().max(500).optional(),
});

export const enquiryConsentSchema = z.object({
  confirmAccurate: z.boolean().refine((value) => value, "Please confirm your information is accurate"),
  agreePrivacy: z.boolean().refine((value) => value, "Please agree to the Privacy Policy to continue"),
});

export const enquirySchema = enquiryDetailsSchema
  .extend(enquirySituationSchema.shape)
  .extend(enquiryGoalsSchema.shape)
  .extend(enquiryConsentSchema.shape);

export type EnquiryFormData = z.infer<typeof enquirySchema>;
